export default __webpack_public_path__ + "media/salad_3.ff81b47b.png";